import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMenu, FiX, FiArrowRight } from 'react-icons/fi';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'About', path: '/about' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="fixed w-full z-50 top-0 left-0 flex flex-col font-sans transition-all duration-300">
      {/* Top Floating Bar - Visible on Every Page */}
      <div className="bg-brand-purple text-white relative z-50">
        <a
          href="https://rgleadership.giantos.com/store/5-voices"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-full py-3 px-4 text-center text-xs md:text-sm font-bold tracking-widest hover:bg-white/10 transition-colors uppercase"
        >
          <span>Take a FREE 5 Voices Assessment HERE</span>
          <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4 mb-0.5" />
        </a>
      </div>

      <nav className="w-full py-4 bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm relative z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center space-x-2 cursor-pointer group">
              <div className="w-8 h-8 bg-brand-purple rounded flex items-center justify-center group-hover:bg-brand-black transition-colors">
                <span className="text-white font-black text-sm">RG</span>
              </div>
              <span className="text-xl font-black tracking-tight text-brand-black group-hover:text-brand-purple transition-colors">
                RG Leadership
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`text-sm font-bold transition-colors ${
                    isActive(item.path) ? 'text-brand-purple' : 'text-gray-600 hover:text-brand-black'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link to="/contact">
                <button className="bg-brand-black text-white px-6 py-3 rounded-lg font-bold text-sm hover:bg-brand-purple transition-colors">
                  Book Consultation
                </button>
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button className="md:hidden" onClick={() => setIsOpen(!isOpen)}>
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-6 h-6 text-brand-black" />
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden bg-white border-b border-gray-100 overflow-hidden"
            >
              <div className="px-4 py-6 flex flex-col space-y-4">
                {navItems.map((item) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={`text-lg font-bold ${
                      isActive(item.path) ? 'text-brand-purple' : 'text-brand-black'
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </div>
  );
};

export default Header;